<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <!-- <b-col :md="newBatch == false ? '7' : '6'"> -->
                  <b-col>
                    <div class="float-left">
                      <h5 class="mt-2 mr-3" v-if="newBatch == false">
                        Order Management
                      </h5>
                      <h5 class="mt-2 mr-3" v-else>
                        Create Batch
                        <span class="fs-14"
                          >({{ selectedBatch.length }} selected)</span
                        >
                      </h5>
                    </div>
                    <div
                      class="cart-mode float-right order-mgmt"
                      v-if="newBatch == false"
                    >
                      <!-- <b-tabs pills card v-model="mode">
                        <b-tab title="View Orders"></b-tab>
                        <b-tab title="View Batches"></b-tab>
                      </b-tabs> -->
                    </div>
                  </b-col>
                  <b-col md="4" class="">
                    <b-input-group class="box-shadow">
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model="search"
                        placeholder="Search Orders (Press enter to search)"
                        v-on:keyup.enter="searchbar"
                        class="search"
                        autocomplete="off"
                        :disabled="$loading"
                        v-shortkey.focus="['ctrl', 's']"
                        autofocus
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <!-- <b-col :md="newBatch == false ? '2' : '3'" class="pl-0">
                    <div class="d-flex">
                      <b-button
                        class="grey-btn w-100"
                        v-if="newBatch == false"
                        @click="newBatch = true"
                        >Create New Batch</b-button
                      >
                      <b-button
                        class="grey-btn mr-2 w-100"
                        v-if="newBatch == true"
                        @click="newBatch = false"
                        >Cancel</b-button
                      >
                      <b-button
                        variant="secondary"
                        class="w-100"
                        v-if="newBatch == true"
                        @click="$bvModal.show('save-batch-modal')"
                        >Save Batch</b-button
                      >
                    </div>
                  </b-col> -->
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col lg="8">
                <b-button
                  class="mr-2 toggle-layout float-left"
                  @click="listView = !listView"
                  :disabled="batchList.length === 0 || orderList.length === 0"
                >
                  <span v-if="listView"
                    ><font-awesome-icon
                      :icon="['fas', 'th']"
                      class="mr-2"
                    />Grid View</span
                  >
                  <span v-else
                    ><font-awesome-icon
                      :icon="['fas', 'bars']"
                      class="mr-2"
                    />List View</span
                  >
                </b-button>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn">
                    Date:&nbsp;
                    <span v-if="selectedDate.length == 0"> Anytime</span>
                    <span v-else v-text="showDataFilterContent"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown list-unstyled">
                      <li v-for="(options, i) in dateList" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.name }}
                          <input
                            type="radio"
                            :value="options.key"
                            v-model="selectedDate"
                            @change="filterOrder"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn"
                    >Status:&nbsp;
                    <span v-if="selectedStatus.length == 0"> All</span>
                    <span v-else v-html="showStatusFilterContent"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown list-unstyled">
                      <li v-for="(options, i) in filterData.status" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options }}
                          <input
                            type="checkbox"
                            :value="options"
                            v-model="selectedStatus"
                            @change="filterOrder"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn"
                    >MOP:&nbsp;
                    <span v-if="selectedMOP.length == 0"> All</span>
                    <span v-else v-html="showMOPFilterContent"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown list-unstyled">
                      <li v-for="(options, i) in filterData.mop" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options }}
                          <input
                            type="checkbox"
                            :value="options"
                            v-model="selectedMOP"
                            @change="filterOrder"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn"
                    >Sort by:&nbsp;
                    <span v-if="selectedSort.length == 0">Newest First</span>
                    <span v-else v-text="showSortFilterContent"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown list-unstyled">
                      <li v-for="(options, i) in filterData.sort" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.name }}
                          <input
                            type="radio"
                            :value="i"
                            v-model="selectedSort"
                            @change="filterOrder"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
              </b-col>
              <b-col lg="4" class="text-right">
                <b-button
                  variant="danger"
                  size="sm"
                  style="padding: 0.525rem 1rem"
                  @click="resetFilter"
                  :disabled="resetFilterBtnEnabled.length === 0"
                  >Reset Filter</b-button
                >
                <b-button
                  variant="danger"
                  size="sm"
                  style="padding: 0.525rem 1rem"
                  v-if="newBatch == true"
                  :disabled="selectedBatch.length == ''"
                  @click="clearSelection()"
                  class="mx-2"
                  >Clear Selected</b-button
                >
                <b-button
                  size="sm"
                  v-if="newBatch == true"
                  class="grey-btn"
                  style="padding: 0.555rem 1rem !important"
                  >Select All</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div v-bar>
            <div>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2">
                <div v-if="orderList.length !== 0 && listView == false">
                  <!-- List View-->
                  <div
                    class="pill p-3 box-shadow mb-2"
                    v-for="item in orderList.data"
                    :key="item.id"
                    :class="{
                      completed:
                        item.status == 'packed' ||
                        item.status == 'Confirmed' ||
                        item.status == 'Packed' ||
                        item.status == 'being_packed' ||
                        item.status == 'Order Fulfilled',
                      pending:
                        item.status == 'Pending' || item.status == 'Cancelled',
                      shipped: item.status == 'Picked by Customer',
                      hidden:
                        item.status != selectedBatchStatus &&
                        selectedBatchStatus !== '',
                    }"
                    @click="orderSummary(item.order_id)"
                  >
                    <b-row class="w-100" style="display: inline-table">
                      <b-col style="display: table-cell; width: 14%">
                        <div class="d-flex">
                          <div class="custom-check" v-if="newBatch == true">
                            <input
                              type="checkbox"
                              :value="item.order_number"
                              :id="item.order_number"
                              v-model="selectedBatch"
                              @click="clickBatch(item)"
                            />
                            <label :for="item.order_id"></label>
                            <!-- </span> -->
                          </div>
                          <div class="ml-2">
                            <h6
                              class="mb-1 fw-normal"
                              :class="{
                                'text-success ':
                                  item.status == 'Confirmed' ||
                                  item.status == 'Packed' ||
                                  item.status == 'item_picked' ||
                                  item.status == 'being_packed' ||
                                  item.status == 'Order Fulfilled',
                                'text-danger': item.status == 'Pending',
                                'text-muted':
                                  item.status == 'Picked by Customer',
                              }"
                            >
                              <span v-text="item.status" />
                            </h6>
                            <p v-text="item.date" />
                          </div>
                        </div>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%"
                      >
                        <label for class="mb-0">Order Number</label>
                        <p v-text="item.order_id" />
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 12%"
                      >
                        <label for class="mb-0">Source</label>
                        <p v-text="item.source" />
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 14%"
                      >
                        <label for class="mb-0">Customer Name</label>
                        <p v-text="item.name" />
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%"
                      >
                        <label for class="mb-0">Payment Status</label>
                        <p
                          v-text="item.p_status"
                          :class="{
                            'text-danger': item.p_status == 'Incomplete',
                          }"
                        ></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 10%"
                      >
                        <label for class="mb-0">Mode of Payment</label>
                        <!-- <p
                          :class="{ 'text-muted': item.mop_list.length === 0 }"
                        >
                          {{
                            item.mop_list.length !== 0
                              ? mopStr(item.mop_list)
                              : "None"
                          }}
                        </p> -->
                        <p
                          class="mb-0"
                          v-show="item.mop_list.length === 0"
                          :class="{ 'text-muted': item.mop_list.length === 0 }"
                        >
                          None
                        </p>
                        <p
                          class="mb-0"
                          v-show="item.mop_list.length !== 0"
                          v-for="(mop, index) in item.mop_list"
                          :key="index"
                          v-text="mop"
                        ></p>
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 5%"
                      >
                        <label for class="mb-0">Items</label>
                        <p v-text="item.item_count" />
                      </b-col>
                      <b-col
                        class="align-top"
                        style="display: table-cell; width: 2%"
                      >
                        <label for class="mb-0">Total Amount</label>
                        <p v-text="currencySymbol + formatAmount(item.total)" />
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex flex-wrap">
                    <b-col
                      md="4"
                      v-for="item in orderList.data"
                      :key="item.id"
                      class="pl-0"
                    >
                      <div
                        class="pill p-3 box-shadow mb-3"
                        :class="{
                          completed:
                            item.status == 'packed' ||
                            item.status == 'Confirmed' ||
                            item.status == 'Packed' ||
                            item.status == 'being_packed' ||
                            item.status == 'Order Fulfilled',
                          pending:
                            item.status == 'Pending' ||
                            item.status == 'Cancelled',
                          shipped: item.status == 'Picked by Customer',
                        }"
                      >
                        <b-row>
                          <b-col md="7">
                            <div class="d-flex status">
                              <div class="custom-check" v-if="newBatch == true">
                                <input
                                  type="checkbox"
                                  :value="item.order_id"
                                  :id="item.order_id"
                                  v-model="selectedBatch"
                                  @click="clickBatch(item)"
                                />
                                <label
                                  :for="item.order_id"
                                  :id="item.order_id"
                                />
                                <!-- </span> -->
                              </div>
                              <div class="ml-2">
                                <h6
                                  class="mb-1 fw-normal"
                                  :class="{
                                    'text-success ':
                                      item.status == 'Confirmed' ||
                                      item.status == 'packed',
                                    'text-danger': item.status == 'Pending',
                                    'text-muted': item.status == 'shipped',
                                  }"
                                >
                                  <span v-text="item.status">Pending</span>
                                </h6>
                                <p class="fs-12" v-text="item.date" />
                              </div>
                            </div>
                          </b-col>
                          <b-col md="5">
                            <label
                              for
                              class="mb-0 fs-11"
                              v-text="item.source"
                            />
                            <p class="fs-12" v-text="item.order_id" />
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="3">
                            <label for class="mb-0 fs-11">Customer Name</label>
                            <p class="fs-12" v-text="item.name" />
                          </b-col>
                          <b-col md="4">
                            <label for class="mb-0 fs-11"
                              >MOP
                              <span
                                v-text="'(' + item.p_status + ')'"
                                :class="{
                                  'text-danger': item.p_status == 'Incomplete',
                                }"
                              />
                            </label>
                            <!-- <p
                              :class="{
                                'text-muted': item.mop_list.length === 0,
                              }"
                            >
                              {{
                                item.mop_list.length !== 0
                                  ? mopStr(item.mop_list)
                                  : "None"
                              }}
                            </p> -->
                            <p
                              class="mb-0"
                              v-show="item.mop_list.length === 0"
                              :class="{
                                'text-muted': item.mop_list.length === 0,
                              }"
                            >
                              None
                            </p>
                            <p
                              class="mb-0"
                              v-show="item.mop_list.length !== 0"
                              v-for="(mop, index) in item.mop_list"
                              :key="index"
                              v-text="mop"
                            />
                          </b-col>
                          <b-col md="2">
                            <label for class="mb-0 fs-11">Items</label>
                            <p class="fs-12" v-text="item.item_count" />
                          </b-col>
                          <b-col md="2">
                            <label for class="mb-0 fs-11">Total Amount</label>
                            <p
                              class="fs-12"
                              v-text="currencySymbol + formatAmount(item.total)"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </div>
                </div>
                <div
                  v-if="batchList.length === 0 || orderList.length === 0"
                  class="d-flex align-items-center justify-content-center h-100"
                >
                  <h5 class="fw-normal text-muted fs-15" v-if="!$loading">
                    No {{ tabMode }} found.
                  </h5>
                </div>
                <!-- <div
                  v-if="search != '' && batchList == ''"
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <h5 class="fw-normal" v-if="$loading == false">No invoices found.</h5>
                </div>-->
              </div>
            </div>
          </div>

          <!-- Save batch infomration-->
          <b-modal id="save-batch-modal" size="md" centered hide-footer>
            <template v-slot:modal-title>
              Additional Batch Information
            </template>
            <div class="d-block">
              <b-form-group id="name" label="Batch Name" label-for="name">
                <b-form-input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter name (Leave blank to auto-generate)"
                  style="border: none"
                />
              </b-form-group>
              <b-form-group
                id="name"
                label="Batch Description"
                label-for="name"
              >
                <b-form-input
                  id="description"
                  name="name"
                  type="text"
                  placeholder="Add Description (Leave blank to auto-generate)"
                  style="border: none"
                />
              </b-form-group>
            </div>
            <div class="mt-3 text-right">
              <b-button variant="primary">Save Batch</b-button>
            </div>
          </b-modal>

          <!-- DatePicker Modal -->
          <b-modal
            ref="date-picker-modal"
            hide-footer
            centered
            :title="dateModalTitle"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
          >
            <div class="d-block">
              <b-row>
                <b-col>
                  <label v-if="selectedDate == 'date_range'">Start Date</label>
                  <datepicker
                    :placeholder="dateLabel"
                    input-class="form-control"
                    v-model="startDate"
                    :minimumView="dateView"
                    :maximumView="dateView"
                    :disabled-dates="{ from: fromDate }"
                    :format="customFormatter"
                  />
                </b-col>
                <b-col v-if="selectedDate == 'date_range'">
                  <label for>End Date</label>
                  <datepicker
                    placeholder="Select End Date"
                    input-class="form-control"
                    v-model="endDate"
                    :minimumView="dateView"
                    :maximumView="dateView"
                    :disabled-dates="{ from: fromDate, to: startDate }"
                    :format="customFormatter"
                  />
                </b-col>
              </b-row>
            </div>
            <b-button
              class="btn btn-danger float-right px-4 mt-4 ml-4"
              @click="cancelDatePickerModal"
              >Cancel</b-button
            >
            <b-button
              class="btn grey-btn float-right px-4 mt-4"
              @click="filterOrder('date')"
              :disabled="dateFilterBtnisEnabled"
            >
              <span v-if="!$loading">Apply Filter</span>
              <b-spinner small v-if="$loading" />
            </b-button>
          </b-modal>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import FilterButton from "../components/FilterButton.vue";

// import * as msg from "../message";

export default {
  name: "create-batch",
  components: {
    Dashboard,
    Loading,
    Datepicker,
    FilterButton,
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    tabMode() {
      return this.mode == 0 ? "order" : "batch";
    },
    showDataFilterContent() {
      if (["today", "yesterday", "last_week"].includes(this.selectedDate)) {
        return _.find(this.dateList, { key: this.selectedDate }).name;
      } else if (this.selectedDate == "specific_day") {
        return this.startDate != ""
          ? this.$moment(this.startDate).format("DD-MMM-YYYY")
          : "Select Day";
      } else if (this.selectedDate == "specific_month") {
        return this.startDate != ""
          ? this.$moment(this.startDate).format("MMMM YYYY")
          : "Select Month";
      } else if (this.selectedDate == "specific_year") {
        return this.startDate != ""
          ? this.$moment(this.startDate).format("YYYY")
          : "Select Year";
      } else if (this.selectedDate == "date_range") {
        return this.startDate != "" && this.endDate != ""
          ? this.$moment(this.startDate).format("DD MMM YYYY") +
              " - " +
              this.$moment(this.endDate).format("DD MMM YYYY")
          : "Select Date Range";
      }
    },
    customFormatter() {
      if (this.selectedDate == "specific_day") {
        return this.$moment(this.startDate).format("DD MMMM YYYY");
      } else if (this.selectedDate == "specific_month") {
        return this.$moment(this.startDate).format("MMMM YYYY");
      } else if (this.selectedDate == "specific_year") {
        return this.$moment(this.startDate).format("YYYY");
      } else {
        return this.$moment(this.startDate).format("DD MMMM YYYY");
      }
    },
    dateFilterBtnisEnabled() {
      if (this.selectedDate == "date_range") {
        return this.startDate == "" && this.endDate == "" ? true : false;
      } else {
        return this.startDate == "" ? true : false;
      }
    },
    showStatusFilterContent() {
      if (this.selectedStatus.length == 1) {
        return this.selectedStatus[0];
      } else {
        return this.selectedStatus.join(",");
      }
    },
    showMOPFilterContent() {
      if (this.selectedMOP.length == 1) {
        return this.selectedMOP[0];
      } else {
        return this.selectedMOP.join(",");
      }
    },
    showSortFilterContent() {
      if (Array.isArray(this.selectedSort)) {
        return this.filterData.sort[0].name;
      } else {
        return this.filterData.sort[this.selectedSort].name;
      }
    },
    resetFilterBtnEnabled() {
      return _.filter(this.filter, (item) => item !== "");
    },
  },
  data() {
    return {
      orderList: [],
      filterData: [],
      selectedDate: "",
      dateModalTitle: "",
      selectedStatus: [],
      selectedMOP: [],
      selectedSort: [],
      mode: 0,
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      searchedTerm: "",
      newBatch: false,
      listView: false,
      batchList: [],
      isShow: false,
      isSearchShow: false,
      search: "",
      startDate: "",
      finalDate: "",
      specDay: "",
      specMonth: "",
      specYear: "",
      rangePopup: true,
      invoicedate: "",
      notFound: true,
      showSearchTerm: false,
      selectedBatch: [],
      selectedBatchStatus: "",
      dateList: [
        {
          key: "today",
          name: "Today",
        },
        {
          key: "yesterday",
          name: "Yesterday",
        },
        {
          key: "last_week",
          name: "Last 7 Days",
        },
        {
          key: "specific_day",
          name: "Day..",
        },
        {
          key: "specific_month",
          name: "Month..",
        },
        {
          key: "specific_year",
          name: "Year..",
        },
        {
          key: "date_range",
          name: "Select Date Range",
        },
      ],
      filter: {
        status: "",
        mop: "",
        sort: "",
        start_date: "",
        end_date: "",
        search: "",
      },
      endDate: "",
      fromDate: new Date(),
      dateLabel: "",
      dateView: "",
    };
  },
  async created() {
    await this.getOrderList();
  },
  methods: {
    clickBatch(e) {
      this.selectedBatchStatus = e.status;
    },
    clearSelection() {
      this.selectedBatch = [];
      this.selectedBatchStatus = "";
    },
    mopStr(arr) {
      return arr.join(",");
    },
    async getOrderList() {
      this.$loading = true;
      await axios
        .post("/oms/order-list", this.essentialsData)
        .then((res) => {
          this.orderList = res.data.data;
          this.filterData = res.data.filter;
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    filterOrder(val = "none") {
      // let data = { start_date: "", end_date: "", sort: 0, status: "", mop: "" };
      if (
        val == "date" ||
        ["today", "yesterday", "last_week"].includes(this.selectedDate)
      ) {
        this.dateFilter();
        if (this.selectedDate == "specific_day") {
          this.filter.start_date = this.$moment(this.startDate).format(
            "YYYY-MM-DD"
          );
          this.filter.end_date = this.$moment(this.startDate).format(
            "YYYY-MM-DD"
          );
        } else if (this.selectedDate == "specific_month") {
          this.filter.start_date = this.$moment(this.startDate)
            .startOf("month")
            .format("YYYY-MM-DD");
          this.filter.end_date = this.$moment(this.startDate)
            .endOf("month")
            .format("YYYY-MM-DD");
        } else if (this.selectedDate == "specific_year") {
          this.filter.start_date = this.$moment(this.startDate)
            .startOf("year")
            .format("YYYY-MM-DD");
          this.filter.end_date = this.$moment(this.startDate)
            .endOf("year")
            .format("YYYY-MM-DD");
        } else if (this.selectedDate == "date_range") {
          this.filter.start_date = this.$moment(this.startDate).format(
            "YYYY-MM-DD"
          );
          this.filter.end_date = this.$moment(this.endDate).format(
            "YYYY-MM-DD"
          );
        } else {
          this.filter.start_date = this.startDate;
          this.filter.end_date = this.endDate;
        }
        this.$refs["date-picker-modal"].hide();
      } else if (
        [
          "specific_day",
          "specific_month",
          "specific_year",
          "date_range",
        ].includes(this.selectedDate)
      ) {
        return this.dateFilter();
      }
      if (!Array.isArray(this.selectedSort)) {
        this.filter.sort = this.selectedSort;
      }
      if (this.selectedStatus.length !== 0) {
        this.filter.status = JSON.stringify(this.selectedStatus);
      }
      if (this.selectedMOP.length !== 0) {
        this.filter.mop = JSON.stringify(this.selectedMOP);
      }
      this.$loading = true;
      let postData = Object.assign(this.filter, this.essentialsData);
      axios
        .post("/oms/order-list", postData)
        .then((res) => {
          this.orderList = res.data.data;
          this.filterData = res.data.filter;
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    dateFilter() {
      if (this.selectedDate == "specific_day") {
        this.dateModalTitle = "Select Specific Day";
        this.dateLabel = "Select Day";
        this.dateView = "day";
        this.$refs["date-picker-modal"].show();
      } else if (this.selectedDate == "specific_month") {
        this.dateModalTitle = "Select Specific Month";
        this.dateLabel = "Select Month";
        this.dateView = "month";
        this.$refs["date-picker-modal"].show();
      } else if (this.selectedDate == "specific_year") {
        this.dateModalTitle = "Select Specific Year";
        this.dateLabel = "Select Year";
        this.dateView = "year";
        this.$refs["date-picker-modal"].show();
      } else if (this.selectedDate == "date_range") {
        this.dateModalTitle = "Select Date Range";
        this.dateLabel = "Select Start Date";
        this.dateView = "day";
        this.$refs["date-picker-modal"].show();
      } else if (this.selectedDate == "today") {
        this.startDate = this.$moment().format("YYYY-MM-DD");
        this.endDate = this.$moment().format("YYYY-MM-DD");
      } else if (this.selectedDate == "yesterday") {
        this.startDate = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        this.endDate = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (this.selectedDate == "last_week") {
        this.startDate = this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        this.endDate = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      }
    },
    cancelDatePickerModal() {
      this.$refs["date-picker-modal"].hide();
      this.startDate = "";
      this.endDate = "";
    },
    async resetFilter() {
      this.filter = {
        start_date: "",
        end_date: "",
        mop: "",
        status: "",
        sort: "",
      };
      this.selectedMOP = [];
      this.selectedSort = [];
      this.selectedStatus = [];
      this.selectedDate = [];
      this.startDate = "";
      this.endDate = "";
      await this.getOrderList();
    },
    orderSummary(id) {
      this.$store.commit("billing/setTransactionSubType", "order");
      this.$router.push("order-summary/" + id);
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-view {
  .pill {
    padding-left: 40px !important;
    .status {
      margin-left: -26px;
    }
  }
}
.toggle-layout {
  background: $dark-card-title-header !important;
  color: #606060 !important;
  border: 1px solid transparent;
  .fa-bars {
    font-size: 13px;
  }
}
.theme-dark .customer-info {
  background-color: #202020 !important;
  .custom-select {
    border: none !important;
  }
}
.btn-success.disabled,
.btn-success:disabled {
  background: #808080;
  border-color: #808080;
}
.grey-outline-btn {
  border: 1px #808080 solid;
  color: #fff;
  background: #808080;
  width: 120px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.custom-select {
  font-size: 13px;
}
.theme-light .table-dark-bg {
  background: $grey-btn-bg;
  height: calc(100vh - 109px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
.theme-light .table-dark-bg.full,
.theme-dark .table-dark-bg.full {
  height: calc(100vh - 65px);
}
.theme-dark .table-dark-bg {
  height: calc(100vh - 109px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
.vdp-datepicker input {
  height: calc(2.55rem + 0px);
}
.pill {
  border-radius: 5px;
  background: $white-color;
  position: relative;
  &.hidden {
    opacity: 0.3;
    &:hover {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  &:before {
    width: 5px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  .return {
    color: #6699cc;
  }
}

h4 {
  color: $mid-grey;
}
h5 {
  color: $grey-color;
  span {
    color: $dark-card-text;
  }
}

.completed.pill {
  &:before {
    background: $success-btn;
  }
}
.pending.pill {
  &:before {
    background: $danger-dark;
  }
}
.shipped.pill {
  &:before {
    background: $dark-card-text;
  }
}
.completed h6 span {
  color: $success-btn;
}
.search-term-badge {
  font-weight: normal;
  font-size: 12px;
}
.header-elements .form-control:focus {
  background-color: #fff !important;
  border: 1px transparent !important;
}
</style>
